const PREFIX = "/reducers/qara/";
 
export const SET_QARA_MESSAGES = `${PREFIX}SET_QARA_MESSAGES`;
export const IS_LOADING = `${PREFIX}IS_LOADING`;
export const SET_QARA_ERROR = `${PREFIX}SET_QARA_ERROR`;
export const SET_QARA_SESSION_ID = `${PREFIX}SET_QARA_SESSION_ID`; 